import type { IngestionRun, IssueSeverity } from '../../../../types/ingestion'

export const ARTEFACT_STATUS_COLOURS: Record<string, string> = {
  completed: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-950/50 dark:text-emerald-400',
  failed: 'bg-red-100 text-red-700 dark:bg-red-950/50 dark:text-red-400',
  empty: 'bg-amber-100 text-amber-700 dark:bg-amber-950/50 dark:text-amber-400',
  missing: 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-400',
}

export const ISSUE_SEVERITY_COLOURS: Record<IssueSeverity, string> = {
  error: 'bg-red-100 text-red-700 dark:bg-red-950/50 dark:text-red-400',
  warning: 'bg-amber-100 text-amber-700 dark:bg-amber-950/50 dark:text-amber-400',
  info: 'bg-sky-100 text-sky-700 dark:bg-sky-950/50 dark:text-sky-400',
}

export const HOSTNAME_MATCH_COLOURS: Record<string, string> = {
  matched: 'text-emerald-600 dark:text-emerald-400',
  mismatched: 'text-red-600 dark:text-red-400',
  unchecked: 'text-slate-500 dark:text-slate-400',
}

export function canVerifyRun(run: IngestionRun): boolean {
  return (
    (run.status === 'completed' || run.status === 'completed_with_issues') &&
    !run.isVerified &&
    !run.isCorrupt
  )
}

export function canFlagCorrupt(run: IngestionRun): boolean {
  return run.isVerified && !run.isCorrupt
}
